module.exports = __webpack_public_path__ + "img/acc8.a95e81b7.png";